<p class="title"
  [class.noSubtext]="!hasTotalCost && !hasItemCount">
  {{pageTitle}}
</p>
<p class="description">
  @if (hasTotalCost) {
    <span>{{totalCost | currency}} /</span>
  }
  @if (hasItemCount) {
    {{itemCount}} <span class="item-label">{{itemLabel}}</span>
  }
</p>
